import { useCallback, useState, KeyboardEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import * as A from '../Auth.style';
import theme from '@styles/theme';
import { onChangeEventType } from '@utils/types';
import useEnter from '@hooks/useEnter';
import { userLogin } from '@modules/authentication';

import { FlexBox, RegularFont } from '@components/styled/StyledComponents';
import StyledInput from '@components/styled/StyledInput';
import StyledPassword from '@components/styled/StyledPassword';
import StyledButton from '@components/styled/StyledButton';

const Login = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const onEnter = useEnter();
    const [inputs, setInputs] = useState({
        email: '',
        password: ''
    });

    const onChange = useCallback(
        (e: onChangeEventType) => {
            const { name, value } = e.target;

            setInputs({
                ...inputs,
                [name]: value
            });
        },
        [inputs]
    );

    const handleLogin = async () => {
        const { email, password } = inputs;

        if (email === '' || password === '') {
            toast.warning('로그인 정보를 입력해주세요.');
            return;
        }
        try {
            await userLogin(email);

            // await adminLogin({
            //     variables: {
            //         account: email,
            //         password
            //     },
            //     onCompleted: (data) => {
            //         userLogin(data.adminLogin as string);
            //     }
            // });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <A.LoginForm>
            <A.Title>관리자 로그인</A.Title>
            <A.SubTitle>헬로미디어 병·의원용 관리자 페이지입니다</A.SubTitle>
            <StyledInput
                name="email"
                value={inputs.email}
                onChange={onChange}
                placeholder="이메일"
                margin="0 0 8px"
                borderRadius={0}
            />
            <StyledPassword
                name="password"
                value={inputs.password}
                onChange={onChange}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) =>
                    onEnter(e, handleLogin)
                }
                placeholder="비밀번호"
                margin="0 0 12px"
                borderRadius={0}
            />
            <FlexBox $justifyContent="flex-end" $alignItems="center">
                <A.LinkButton to={`/auth/find-id`}>이메일 찾기</A.LinkButton>
                <A.LinkButton to={`/auth/reset-password`}>
                    비밀번호 찾기
                </A.LinkButton>
            </FlexBox>
            <StyledButton
                title="로그인"
                margin="32px 0 20px"
                width={343}
                fontSize={14}
                onClick={handleLogin}
                borderRadius={0}
                bgColor={theme.colors.pointBlue}
            />
            <FlexBox
                $justifyContent="center"
                $fontColor={theme.colors.deepGrayFontColor}
                $fontSize={14}
            >
                아직 헬로미디어 회원이 아닌가요?
                <A.JoinButton
                    onClick={() => navigate('/auth/join')}
                    $fontColor={theme.colors.pointBlue}
                >
                    회원가입
                </A.JoinButton>
            </FlexBox>
        </A.LoginForm>
    );
};

export default Login;
